import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { routeMap } from './app.settings';
import { NotFoundComponent } from './core/errors/pages/not-found/not-found.component';

const urlPath = window.location.pathname;
const match = routeMap.find((el) => el.regex.test(urlPath));

const routes: Routes = [];

if (match) {
  routes.push({
    path: '',
    loadChildren: match.f,
  });
} else {
  // If we can't find a path, we are working in standalone mode.
  window.location.href = '/fr/evc-segment';
}

routes.push({
  path: '**',
  component: NotFoundComponent,
});

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
